import * as React from 'react'

import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import CourseSyllabus from 'components/atomic/organisms/syllabus/course'
import Text from 'components/atomic/atoms/text'
import Icon from 'components/atomic/atoms/icon'

import { Track } from 'types/types'

interface SyllabusProps {
    course: Track
}

const Syllabus = (props: SyllabusProps) => {
    const { t }: I18n = useTranslation()

    return (
        <div>
            <Box mb={4}>
                <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                    <Icon fontSize="small" color="primary" name="helpOutline" />
                    <Text sx={{ textTransform: 'uppercase', fontWeight: 'bold' }} color="primary">
                        {t('path:syllabusSection.label')}
                    </Text>
                </Stack>
                <Text variant="h4">{t('path:syllabusSection.title')}</Text>
            </Box>
            <CourseSyllabus course={props.course} />
        </div>
    )
}

export default Syllabus
